import React from "react";
import SideMenu, { SideMenuLink, SideMenuSpacer } from "@amzn/meridian/esm/components/side-menu";
import Row from "@amzn/meridian/esm/components/row";
import Box from "@amzn/meridian/esm/components/box";
import { Text, Theme } from "@amzn/meridian";

const SidebarInClient = ({ selectedTab, setSelectedTab, isVerboseSummariesEnabled }) => {
  const settingsTab = isVerboseSummariesEnabled ? "settings" : "help";
  const settingsLabel = isVerboseSummariesEnabled ? "Settings" : "Feedback";

  return (
    <Theme
      tokens={{
        sideMenuLinkIndicatorColorSelected: "#AFE8D7",
        sideMenuLinkIndicatorColorPressed: "#55AA96",
      }}
    >
      <SideMenu width="176px">
        <SideMenuLink selected={selectedTab === "summaries"} onClick={() => setSelectedTab("summaries")}>
          <Row spacing="none" spacingInset="none">
            <Box width="24px"></Box>
            <Text>Summaries</Text>
          </Row>
        </SideMenuLink>
        <SideMenuLink selected={selectedTab === settingsTab} onClick={() => setSelectedTab(settingsTab)}>
          <Row spacing="none" spacingInset="none">
            <Box width="24px"></Box>
            <Text>{settingsLabel}</Text>
          </Row>
        </SideMenuLink>
        {[...Array(13)].map((_, idx) => (
          <SideMenuSpacer key={idx} />
        ))}
      </SideMenu>
    </Theme>
  );
};

export default SidebarInClient;
